import * as types from '../constants/ActionTypes';

const initialState = {
  elmoTreatments: [],
  receivedResponse: false,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case types.ELMO_EXPERIMENTS_REQUESTED:
      return { ...state, receivedResponse: false };
    case types.ELMO_EXPERIMENTS_RECEIVED:
      return { ...state, elmoTreatments: [...state.elmoTreatments, ...action.payload], receivedResponse: true };
    case types.ELMO_EXPERIMENTS_ERROR:
      return { ...state, elmoTreatments: [...state.elmoTreatments], receivedResponse: false };
    default:
      return state;
  }
}
